export default __webpack_public_path__ + "static/media/icon_4.b11aa59b.png";